module.exports = __webpack_public_path__ + "school/img/practiceMedicineBg.1bc302c9.jpg";